








































import Vue from "vue";

export default Vue.extend({
  name: "ImageTile",
  functional: true,
  props: {
    clickFunction: {
      type: Function,
      required: false
    },
    imgUrl: {
      type: String,
      required: true
    },
    preline: {
      type: String,
      required: true
    },
    headline: {
      type: String,
      required: true
    },
    badge: {
      type: String
    }
  }
});
